import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, Typography } from 'components/alf-design';

const ClaimField = ({ label, id, value, tooltip, children }) => (
  <div>
    {tooltip ? (
      <Typography type="footer" component="div">
        {label}
        <Tooltip
          ariaLabel={tooltip.ariaLabel}
          text={tooltip.text}
          dataFor={tooltip.dataFor}
        />
      </Typography>
    ) : (
      <Typography type="footer" className="mb-[4px]">
        {label}
      </Typography>
    )}
    {children ?? (
      <Typography id={id} type="caption2" className="text-legacy-textDark">
        {value}
      </Typography>
    )}
  </div>
);

ClaimField.propTypes = {
  label: PropTypes.node.isRequired,
  id: PropTypes.string,
  value: PropTypes.node,
  tooltip: PropTypes.shape({
    ariaLabel: PropTypes.string,
    text: PropTypes.string,
    dataFor: PropTypes.string,
  }),
  children: PropTypes.node,
};

export default ClaimField;
